// SEO Pages Data - All 95+ pages for IQES Low Voltage Solutions

// Cities for location-based pages with nearby cities for Hub & Spoke SEO
export const cities = [
  { slug: 'miami', name: 'Miami', state: 'FL', region: 'South Florida', nearby: ['hialeah', 'hollywood', 'fort-lauderdale', 'coral-springs', 'boca-raton'] },
  { slug: 'orlando', name: 'Orlando', state: 'FL', region: 'Central Florida', nearby: ['winter-haven', 'daytona-beach', 'ocala', 'tampa', 'gainesville'] },
  { slug: 'tampa', name: 'Tampa', state: 'FL', region: 'Tampa Bay', nearby: ['sarasota', 'orlando', 'winter-haven', 'fort-myers', 'ocala'] },
  { slug: 'fort-lauderdale', name: 'Fort Lauderdale', state: 'FL', region: 'South Florida', nearby: ['miami', 'hollywood', 'pompano-beach', 'boca-raton', 'coral-springs'] },
  { slug: 'jacksonville', name: 'Jacksonville', state: 'FL', region: 'North Florida', nearby: ['gainesville', 'daytona-beach', 'tallahassee', 'ocala', 'orlando'] },
  { slug: 'west-palm-beach', name: 'West Palm Beach', state: 'FL', region: 'South Florida', nearby: ['boca-raton', 'fort-lauderdale', 'pompano-beach', 'coral-springs', 'miami'] },
  { slug: 'tallahassee', name: 'Tallahassee', state: 'FL', region: 'North Florida', nearby: ['panama-city', 'jacksonville', 'gainesville', 'ocala', 'orlando'] },
  { slug: 'panama-city', name: 'Panama City', state: 'FL', region: 'Panhandle', nearby: ['tallahassee', 'fort-myers', 'jacksonville', 'gainesville', 'tampa'] },
  { slug: 'fort-myers', name: 'Fort Myers', state: 'FL', region: 'Southwest Florida', nearby: ['naples', 'sarasota', 'tampa', 'miami', 'west-palm-beach'] },
  { slug: 'winter-haven', name: 'Winter Haven', state: 'FL', region: 'Central Florida', nearby: ['orlando', 'tampa', 'sarasota', 'daytona-beach', 'fort-myers'] },
  { slug: 'naples', name: 'Naples', state: 'FL', region: 'Southwest Florida', nearby: ['fort-myers', 'sarasota', 'miami', 'tampa', 'west-palm-beach'] },
  { slug: 'sarasota', name: 'Sarasota', state: 'FL', region: 'Southwest Florida', nearby: ['tampa', 'fort-myers', 'naples', 'winter-haven', 'orlando'] },
  { slug: 'gainesville', name: 'Gainesville', state: 'FL', region: 'North Central Florida', nearby: ['ocala', 'jacksonville', 'orlando', 'daytona-beach', 'tallahassee'] },
  { slug: 'ocala', name: 'Ocala', state: 'FL', region: 'North Central Florida', nearby: ['gainesville', 'orlando', 'daytona-beach', 'jacksonville', 'tampa'] },
  { slug: 'daytona-beach', name: 'Daytona Beach', state: 'FL', region: 'East Coast', nearby: ['orlando', 'jacksonville', 'gainesville', 'ocala', 'west-palm-beach'] },
  { slug: 'boca-raton', name: 'Boca Raton', state: 'FL', region: 'South Florida', nearby: ['west-palm-beach', 'fort-lauderdale', 'pompano-beach', 'coral-springs', 'miami'] },
  { slug: 'coral-springs', name: 'Coral Springs', state: 'FL', region: 'South Florida', nearby: ['fort-lauderdale', 'pompano-beach', 'boca-raton', 'hollywood', 'miami'] },
  { slug: 'pompano-beach', name: 'Pompano Beach', state: 'FL', region: 'South Florida', nearby: ['fort-lauderdale', 'boca-raton', 'coral-springs', 'hollywood', 'west-palm-beach'] },
  { slug: 'hollywood', name: 'Hollywood', state: 'FL', region: 'South Florida', nearby: ['miami', 'fort-lauderdale', 'hialeah', 'pompano-beach', 'coral-springs'] },
  { slug: 'hialeah', name: 'Hialeah', state: 'FL', region: 'South Florida', nearby: ['miami', 'hollywood', 'fort-lauderdale', 'coral-springs', 'boca-raton'] },
];

// Helper function to get nearby cities with full data
export const getNearbyCities = (citySlug) => {
  const city = cities.find(c => c.slug === citySlug);
  if (!city || !city.nearby) return [];
  return city.nearby.map(slug => cities.find(c => c.slug === slug)).filter(Boolean);
};

// Services for service + location pages
export const services = [
  {
    slug: 'cctv-installation',
    name: 'CCTV Installation',
    nameEs: 'Instalación de CCTV',
    shortName: 'CCTV',
    description: 'Professional CCTV and security camera installation services',
    icon: 'Camera',
    keywords: ['CCTV', 'security cameras', 'video surveillance', 'IP cameras', 'DVR', 'NVR'],
    features: [
      'HD & 4K camera systems',
      'Remote viewing setup',
      'Night vision cameras',
      'Motion detection alerts',
      'Cloud & local storage',
      'Professional installation'
    ]
  },
  {
    slug: 'fiber-optic-installation',
    name: 'Fiber Optic Installation',
    nameEs: 'Instalación de Fibra Óptica',
    shortName: 'Fiber Optic',
    description: 'Expert fiber optic cable installation and termination services',
    icon: 'Zap',
    keywords: ['fiber optic', 'fiber cable', 'fiber termination', 'fiber splicing', 'FTTH'],
    features: [
      'Single & multi-mode fiber',
      'Fiber splicing & termination',
      'OTDR testing',
      'Fiber to the premises',
      'Backbone cabling',
      'Certified technicians'
    ]
  },
  {
    slug: 'structured-cabling',
    name: 'Structured Cabling',
    nameEs: 'Cableado Estructurado',
    shortName: 'Cabling',
    description: 'Complete structured cabling solutions for voice and data networks',
    icon: 'Network',
    keywords: ['structured cabling', 'network cabling', 'data cabling', 'voice cabling', 'Cat6'],
    features: [
      'Cat5e, Cat6, Cat6A cabling',
      'Patch panel installation',
      'Cable management',
      'Testing & certification',
      'Rack installation',
      'Cable labeling'
    ]
  },
  {
    slug: 'access-control',
    name: 'Access Control',
    nameEs: 'Control de Acceso',
    shortName: 'Access Control',
    description: 'Advanced access control systems for enhanced security',
    icon: 'Lock',
    keywords: ['access control', 'keycard', 'biometric', 'door access', 'security access'],
    features: [
      'Keycard & fob systems',
      'Biometric readers',
      'Mobile access control',
      'Multi-door systems',
      'Integration with CCTV',
      'Cloud management'
    ]
  },
  {
    slug: 'security-cameras',
    name: 'Security Cameras',
    nameEs: 'Cámaras de Seguridad',
    shortName: 'Security Cameras',
    description: 'Commercial and residential security camera installation',
    icon: 'Shield',
    keywords: ['security cameras', 'surveillance', 'IP cameras', 'PTZ cameras', '4K cameras'],
    features: [
      '4K Ultra HD cameras',
      'PTZ cameras',
      'License plate recognition',
      'Facial recognition',
      'Analytics & AI',
      '24/7 monitoring'
    ]
  },
  {
    slug: 'network-installation',
    name: 'Network Installation',
    nameEs: 'Instalación de Redes',
    shortName: 'Networking',
    description: 'Complete network infrastructure installation and setup',
    icon: 'Wifi',
    keywords: ['network installation', 'networking', 'LAN', 'WAN', 'enterprise network'],
    features: [
      'LAN/WAN setup',
      'Switch & router config',
      'VLAN configuration',
      'Network security',
      'WiFi deployment',
      'Network monitoring'
    ]
  },
  {
    slug: 'access-point-installation',
    name: 'Access Point Installation',
    nameEs: 'Instalación de Access Points',
    shortName: 'Access Points',
    description: 'Enterprise wireless access point installation and configuration',
    icon: 'Radio',
    keywords: ['access point', 'WiFi', 'wireless', 'enterprise WiFi', 'WAP'],
    features: [
      'Site survey',
      'Heat mapping',
      'Ubiquiti & Cisco',
      'Mesh networking',
      'Guest networks',
      'Seamless roaming'
    ]
  },
  {
    slug: 'cat6-cabling',
    name: 'Cat6 Cabling',
    nameEs: 'Cableado Cat6',
    shortName: 'Cat6',
    description: 'Professional Cat6 network cable installation services',
    icon: 'Cable',
    keywords: ['Cat6', 'Cat6 cable', 'Cat6 installation', 'ethernet cable', 'network cable'],
    features: [
      'Cat6 certified installation',
      'Up to 10Gbps speed',
      '250MHz bandwidth',
      'Fluke tested',
      'Warranty included',
      'Commercial & residential'
    ]
  },
  {
    slug: 'cat6a-cabling',
    name: 'Cat6A Cabling',
    nameEs: 'Cableado Cat6A',
    shortName: 'Cat6A',
    description: 'High-performance Cat6A cable installation for demanding networks',
    icon: 'Cable',
    keywords: ['Cat6A', 'Cat6A cable', 'augmented Cat6', '10G ethernet', 'shielded cable'],
    features: [
      'Cat6A augmented performance',
      '10Gbps full distance',
      '500MHz bandwidth',
      'Shielded options',
      'Data center grade',
      'Future-proof solution'
    ]
  },
  {
    slug: 'site-survey',
    name: 'Site Survey',
    nameEs: 'Estudio de Sitio',
    shortName: 'Site Survey',
    description: 'Professional site surveys for cabling and wireless projects',
    icon: 'ClipboardCheck',
    keywords: ['site survey', 'wireless survey', 'cable survey', 'network assessment'],
    features: [
      'WiFi heat mapping',
      'Cable pathway assessment',
      'Equipment recommendations',
      'Cost estimation',
      'Project planning',
      'Detailed reports'
    ]
  }
];

// Industries for industry-specific pages
export const industries = [
  {
    slug: 'healthcare',
    name: 'Healthcare',
    nameEs: 'Salud',
    description: 'Low voltage solutions for hospitals, clinics, and medical facilities',
    keywords: ['hospital', 'healthcare', 'medical', 'clinic', 'HIPAA'],
    features: [
      'HIPAA compliant installations',
      'Nurse call systems',
      'Patient monitoring',
      'Medical-grade cabling',
      'Emergency systems',
      'Clean room certified'
    ]
  },
  {
    slug: 'warehouse',
    name: 'Warehouse',
    nameEs: 'Almacén',
    description: 'Security and networking solutions for warehouses and distribution centers',
    keywords: ['warehouse', 'distribution', 'logistics', 'industrial'],
    features: [
      'High-bay camera coverage',
      'Dock door monitoring',
      'Inventory tracking',
      'Industrial-grade equipment',
      'Wide-area WiFi',
      'Forklift tracking'
    ]
  },
  {
    slug: 'retail',
    name: 'Retail',
    nameEs: 'Retail',
    description: 'Security cameras and POS networking for retail stores',
    keywords: ['retail', 'store', 'shop', 'POS', 'loss prevention'],
    features: [
      'Loss prevention systems',
      'POS integration',
      'Customer counting',
      'Heat mapping analytics',
      'Multi-store management',
      'Cloud monitoring'
    ]
  },
  {
    slug: 'office',
    name: 'Office',
    nameEs: 'Oficina',
    description: 'Complete low voltage infrastructure for corporate offices',
    keywords: ['office', 'corporate', 'commercial', 'business'],
    features: [
      'Structured cabling',
      'Conference room AV',
      'Access control',
      'Enterprise WiFi',
      'VoIP ready',
      'Cable management'
    ]
  },
  {
    slug: 'education',
    name: 'Education',
    nameEs: 'Educación',
    description: 'Security and networking for schools and educational institutions',
    keywords: ['school', 'education', 'university', 'campus'],
    features: [
      'Campus-wide coverage',
      'Classroom technology',
      'Emergency notification',
      'Student WiFi',
      'Visitor management',
      'Lockdown systems'
    ]
  },
  {
    slug: 'hospitality',
    name: 'Hospitality',
    nameEs: 'Hospitalidad',
    description: 'Low voltage solutions for hotels, resorts, and restaurants',
    keywords: ['hotel', 'resort', 'restaurant', 'hospitality'],
    features: [
      'Guest WiFi systems',
      'Room access control',
      'POS networking',
      'Surveillance systems',
      'Back-of-house cabling',
      'Digital signage'
    ]
  },
  {
    slug: 'construction',
    name: 'Construction',
    nameEs: 'Construcción',
    description: 'Temporary and permanent low voltage for construction sites',
    keywords: ['construction', 'job site', 'building', 'contractor'],
    features: [
      'Job site cameras',
      'Temporary WiFi',
      'Time-lapse systems',
      'Rugged equipment',
      'Solar powered options',
      'Remote monitoring'
    ]
  }
];

// Product-specific pages
export const products = [
  {
    slug: 'cat5e-vs-cat6',
    name: 'Cat5e vs Cat6 Cabling',
    description: 'Compare Cat5e and Cat6 network cables to choose the right solution',
    keywords: ['cat5e vs cat6', 'difference cat5 cat6', 'which cable to use']
  },
  {
    slug: 'cat6-vs-cat6a',
    name: 'Cat6 vs Cat6A Installation',
    description: 'Understanding the differences between Cat6 and Cat6A cabling',
    keywords: ['cat6 vs cat6a', 'cat6a benefits', 'when to use cat6a']
  },
  {
    slug: 'poe-cameras',
    name: 'PoE Camera Installation',
    description: 'Power over Ethernet camera systems for simplified installation',
    keywords: ['PoE cameras', 'power over ethernet', 'PoE security cameras']
  },
  {
    slug: '4k-security-cameras',
    name: '4K Security Camera Systems',
    description: 'Ultra HD 4K security camera installation services',
    keywords: ['4K cameras', 'ultra HD cameras', '4K CCTV', '8MP cameras']
  },
  {
    slug: 'ptz-cameras',
    name: 'PTZ Camera Installation',
    description: 'Pan-tilt-zoom camera systems for comprehensive coverage',
    keywords: ['PTZ cameras', 'pan tilt zoom', 'motorized cameras']
  },
  {
    slug: 'nvr-systems',
    name: 'NVR System Installation',
    description: 'Network video recorder setup and configuration',
    keywords: ['NVR', 'network video recorder', 'IP camera recorder']
  },
  {
    slug: 'biometric-access',
    name: 'Biometric Access Control',
    description: 'Fingerprint and facial recognition access systems',
    keywords: ['biometric', 'fingerprint access', 'facial recognition']
  },
  {
    slug: 'keycard-systems',
    name: 'Keycard Access Systems',
    description: 'Card reader and fob-based access control installation',
    keywords: ['keycard', 'card reader', 'proximity cards', 'fob access']
  },
  {
    slug: 'wireless-access-points',
    name: 'Wireless Access Point Setup',
    description: 'Enterprise WiFi access point installation and configuration',
    keywords: ['wireless access point', 'WAP', 'enterprise WiFi', 'Ubiquiti']
  },
  {
    slug: 'fiber-splicing',
    name: 'Fiber Optic Splicing',
    description: 'Professional fiber optic splicing and termination services',
    keywords: ['fiber splicing', 'fusion splicing', 'fiber termination']
  },
  {
    slug: 'network-rack-installation',
    name: 'Network Rack Installation',
    description: 'Server rack and network cabinet installation services',
    keywords: ['network rack', 'server rack', 'data cabinet', 'rack mount']
  },
  {
    slug: 'data-center-cabling',
    name: 'Data Center Cabling',
    description: 'High-density cabling solutions for data centers',
    keywords: ['data center', 'high density cabling', 'cable management']
  },
  {
    slug: 'intercom-systems',
    name: 'Intercom System Installation',
    description: 'Video and audio intercom systems for buildings',
    keywords: ['intercom', 'video intercom', 'door intercom', 'building intercom']
  },
  {
    slug: 'nurse-call-systems',
    name: 'Nurse Call Systems',
    description: 'Hospital and healthcare nurse call system installation',
    keywords: ['nurse call', 'patient call', 'hospital call system']
  },
  {
    slug: 'av-installation',
    name: 'AV System Installation',
    description: 'Audio visual system installation for conference rooms',
    keywords: ['AV installation', 'audio visual', 'conference room AV']
  }
];

// Generate all service + location page combinations
export const generateServiceLocationPages = () => {
  const pages = [];
  services.forEach(service => {
    cities.forEach(city => {
      pages.push({
        slug: `${service.slug}-${city.slug}`,
        service: service,
        city: city,
        title: `${service.name} ${city.name}, ${city.state} | IQES`,
        metaTitle: `${service.name} ${city.name} FL | Professional ${service.shortName} Services`,
        metaDescription: `Professional ${service.name.toLowerCase()} services in ${city.name}, Florida. Licensed contractor, free quotes. Call 786-981-3760.`,
        h1: `${service.name} in ${city.name}, Florida`,
        keywords: [...service.keywords, city.name, city.region, 'Florida', 'contractor', 'installation']
      });
    });
  });
  return pages;
};

// Generate all industry + location page combinations
export const generateIndustryLocationPages = () => {
  const pages = [];
  industries.forEach(industry => {
    cities.forEach(city => {
      pages.push({
        slug: `${industry.slug}-${city.slug}`,
        industry: industry,
        city: city,
        title: `${industry.name} Low Voltage ${city.name} | IQES`,
        metaTitle: `${industry.name} Security & Cabling ${city.name} FL | IQES`,
        metaDescription: `Low voltage solutions for ${industry.name.toLowerCase()} in ${city.name}, FL. CCTV, access control, networking. Free quotes. 786-981-3760.`,
        h1: `${industry.name} Low Voltage Solutions in ${city.name}`,
        keywords: [...industry.keywords, city.name, 'low voltage', 'security', 'cabling']
      });
    });
  });
  return pages;
};

// Generate product pages (Florida-wide)
export const generateProductPages = () => {
  return products.map(product => ({
    slug: product.slug,
    product: product,
    title: `${product.name} Florida | IQES`,
    metaTitle: `${product.name} | Professional Installation Florida`,
    metaDescription: `${product.description} Professional installation in Florida. Free quotes. Call 786-981-3760.`,
    h1: product.name,
    keywords: [...product.keywords, 'Florida', 'installation', 'professional']
  }));
};

// Get all SEO pages
export const getAllSeoPages = () => {
  return {
    serviceLocation: generateServiceLocationPages(),
    industryLocation: generateIndustryLocationPages(),
    products: generateProductPages(),
    total: generateServiceLocationPages().length + generateIndustryLocationPages().length + generateProductPages().length
  };
};

export default {
  cities,
  services,
  industries,
  products,
  getAllSeoPages
};
